import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "../ui/tabs";
import SettingsCurrencies from "../settings/SettingsCurrencies";
import SettingsPaymentGateways from "../settings/SettingsPaymentGateways";
import SettingsInstantPayments from "../settings/SettingsInstantPayments";

import SettingsShipping from "../settings/SettingsShipping";
import SettingsAmazon from "../settings/SettingsAmazon";
import SettingsNoon from "../settings/SettingsNoon";
import RolesPermissions from "../settings/RolesPermissions";
import SettingsMedia from "../settings/SettingsMedia";

export default function SettingsTabs() {
    return (
        <Tabs defaultValue="currencies" className="w-full">
            <TabsList className="grid w-full grid-cols-7 mb-6">
                <TabsTrigger value="currencies">Currencies</TabsTrigger>
                <TabsTrigger value="payment_modes">Payment Modes</TabsTrigger>
                <TabsTrigger value="instant_payments">Instant Payments</TabsTrigger>
                <TabsTrigger value="shipping">Shipping</TabsTrigger>
                <TabsTrigger value="marketing">Marketing</TabsTrigger>
                <TabsTrigger value="roles">Roles</TabsTrigger>
                <TabsTrigger value="media">Media</TabsTrigger>
            </TabsList>
            <TabsContent value="currencies">
                <SettingsCurrencies />
            </TabsContent>
            <TabsContent value="payment_modes">
                <SettingsPaymentGateways />
            </TabsContent>
            <TabsContent value="instant_payments">
                <SettingsInstantPayments />
            </TabsContent>
            <TabsContent value="shipping">
                <SettingsShipping />
            </TabsContent>
            <TabsContent value="marketing">
                <div className="space-y-6">
                    <SettingsAmazon />
                    <SettingsNoon />
                </div>
            </TabsContent>
            <TabsContent value="roles">
                <RolesPermissions />
            </TabsContent>
            <TabsContent value="media">
                <SettingsMedia />
            </TabsContent>
        </Tabs>
    );
}
